import React, { FC, useEffect } from 'react';

import { ArtworkType, LegacyArtwork } from 'types';

import { ChromecastProvider } from 'context/ChromecastContext';
import { ArtworkPreviewModalContainer, ModalData } from 'components/artworkPreviewModal/Container';
import { MODAL_ID } from 'apps/homepage/utils/modal';
import { VideoHero } from 'components/VideoHero';

import { NftGridContainer } from '../nftGrid/Container';
import { HeroLead } from '../components/HeroLead';
import { DiscordSection } from '../components/DiscordSection';
import { FAQSection } from '../components/FAQSection';
import { RoadmapSection } from '../components/RoadmapSection';
import { InteriorSceneContainer } from '../interiorScene/Container';

type StateProps = {};

type DispatchProps = {
  afterOpenModal: (data: ModalData, artwork: LegacyArtwork) => void;
  onMount: () => void;
};

type Props = DispatchProps & StateProps;

export const App: FC<Props> = ({ afterOpenModal, onMount }) => {
  useEffect(() => onMount(), []);

  return (
    <div className='nft-landing-page'>
      <div className='mb-4'>
        <VideoHero
          videoId='738920822'
          videoTitle={'Sedition NFTs'}
          videoUrl='nft-landing-page/video-preview.mp4'
          videoThumbnail='nft-landing-page/video-preview.jpg'
          buttonText={'Learn about Sedition NFTs'}
        />
      </div>
      <div className='mb-4'>
        <HeroLead />
      </div>
      <div className='mb-4'>
        <NftGridContainer />
      </div>
      <div className='mb-2 mb-md-4'>
        <InteriorSceneContainer
          artwork={{
            id: 0,
            slug: '',
            title: '',
            thumbnailUrl: '',
            artistUserId: 0,
            artistName: '',
            childrenCount: 0,
            type: ArtworkType.video,
            thumbnailType: 'artwork',
            dominantColor: '',
            availableForPurchase: false,
            soldOut: false,
            forSale: false,
            url: '',
            artistUrl: '',
            price: undefined,
            totalEditions: undefined,
            remainingEditions: 0,
            auctionState: undefined,
            nft: false,
            vip: false,
            giftable: false,
          }}
        />
        <RoadmapSection />
      </div>
      <div className='mb-4 pt-1 pb-4 bg-gradient-into-gray'>
        <FAQSection />
      </div>
      <div className='mb-4'>
        <DiscordSection />
      </div>
      <ChromecastProvider>
        <ArtworkPreviewModalContainer
          modalId={MODAL_ID}
          afterOpenModal={(modalData, artwork) => afterOpenModal(modalData, artwork)}
        />
      </ChromecastProvider>
    </div>
  );
};
